import workspaceQuery from '../../queries/sales/SalesOrderWorkspaceQuery.graphql';
import workspaceCombinedQuery from '../../queries/sales/SalesCombinedWorkspaceQuery.graphql';
import workspaceQuotationQuery from '../../queries/sales/QuotationWorkspaceQuery.graphql';

import listQuery from '../../queries/sales/SalesOrderListQuery.graphql';
import instanceQuery from '../../queries/sales/SalesOrderQuery.graphql';
import defaultQuery from '../../queries/sales/SalesOrderDefault.graphql';
import basicQuery from '../../queries/sales/SalesOrderQueryBasic.graphql';
import mutationQuery from '../../mutations/sales/SalesOrderMutation.graphql';
import temporaryMutationQuery from '../../mutations/sales/SaveOrderTempMutation.graphql';
import aggregateQuery from '../../queries/sales/SalesOrderAggregateQuery.graphql';
import fragment from '../../fragments/sales/SalesOrderFragment.graphql';

import { formActionsForPermissions } from '../../../actions/sales/SalesOrderAction';
import { workspaceForPermissions } from '../../../actions/sales/SalesOrderWorkspaceAction';
import { FilterOperation, IFilterInput, ISalesOrder } from '../../schema/p4types';
import { EntityType, IDropdownOptionRenderer } from '../../../@types/entityTypes';
import React from 'react';
import titleCase from '../../../utils/TitleCase';
import { orRemoteFilterGetter } from '../../../utils/OrRemoteFilterGetter';
import { DocumentNode } from '@apollo/client';

const SalesOrderOptionRenderer: IDropdownOptionRenderer = ({ option }: { option: ISalesOrder }) => {
  const orderNumberLabel = option.orderNumber ? ` - ${option.orderNumber}` : '';
  const customerReferenceLabel = option.customer?.reference ? ` - ${option.customer?.reference}` : '';

  return (
    <span>
      {titleCase(option.orderType ?? 'ORDER')}
      {orderNumberLabel}
      {customerReferenceLabel}
    </span>
  );
};

const SalesOrder: EntityType & {
  workspacePredefinedFilters: Array<IFilterInput>;
  quoteWorkspacePredefinedFilters: Array<IFilterInput>;
  combinedWorkspace: DocumentNode;
  quoteWorkspace: DocumentNode;
} = {
  type: 'SalesOrder',
  title: 'Sales Orders',
  formTitle: 'Sales Order / Quote',
  formUrl: '/Sales/Order/Details/',
  workspaceUrl: '/Sales/Order/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  workspacePredefinedFilters: [
    {
      filterOperation: FilterOperation.Equals,
      filterParameters: {
        field: 'orderType',
        value: 'ORDER',
      },
    },
  ],
  combinedWorkspace: workspaceCombinedQuery,
  quoteWorkspace: workspaceQuotationQuery,
  quoteWorkspacePredefinedFilters: [
    {
      filterOperation: FilterOperation.Equals,
      filterParameters: {
        field: 'orderType',
        value: 'QUOTE',
      },
    },
  ],
  default: defaultQuery,
  basic: basicQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderNumber',
    optionRenderer: SalesOrderOptionRenderer,
    remoteFilter: true,
    remoteFilterGetter: orRemoteFilterGetter(['orderType', 'orderNumber', 'customer.reference']),
  },
  aggregate: aggregateQuery,
  actions: [...formActionsForPermissions, ...workspaceForPermissions],
  fragment,
  screenReference: 'SALES_ORDERS',
};

export default SalesOrder;
